// extracted by mini-css-extract-plugin
export default {"verify-payment-method-modal":"style_verify-payment-method-modal__doN8S","verifyPaymentMethodModal":"style_verify-payment-method-modal__doN8S"};